(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('PreviewPopupController', PreviewPopupController);

    PreviewPopupController.$inject = ['$scope', '$q', '$log', 'eventService', 'modelFilePreviewService', 'processingWorkflowService'];

    function PreviewPopupController($scope, $q, $log, eventService, modelFilePreviewService, processingWorkflowService) {
        var vm = this;
        var canceler = null;

        vm.model = null;
        vm.isPopupOpened = false;
        vm.isStripeLoaded = false;

        vm.isStripeReady = isStripeReady;
        vm.stripeLoaded = stripeLoaded;
        vm.loadStripeFailed = loadStripeFailed;
        vm.hidePreviewPopup = hidePreviewPopup;

        eventService.subscribe($scope, 'ShowPreviewInPopup', showPreviewPopup);

        // -----------------------------------------------------------------------------------

        function showPreviewPopup(model) {
            vm.model = model;
            vm.isPopupOpened = true;

            if (!model.stripePreviewInfo || model.stripePreviewInfo.jobId) {
                getStripePreviewInfo(model);
            }
        }

        function hidePreviewPopup() {
            vm.isPopupOpened = false;
            vm.model = null;
            vm.isStripeLoaded = false;

            if (canceler) {
                canceler.resolve('CANCELED');
            }
        }

        function isStripeReady() {
            return vm.model && vm.model.stripePreviewInfo && vm.isStripeLoaded;
        }

        // ************************************ private functions *****************************************

        function getStripePreviewInfo(model) {

            $log.debug("getStripePreviewInfo for modelId = " + model.id);

            canceler = $q.defer();

            var promise = $q.resolve();
            if (model.stripePreviewInfo && model.stripePreviewInfo.jobId) {
                promise = processingWorkflowService.waitProcessingWorkflowComplete(model.stripePreviewInfo.jobId, canceler.promise);
            }

            promise.then(function () {
                return modelFilePreviewService.getStripePreviewInfo(model.id, canceler.promise)
                    .then(function (previewInfo) {
                        $log.debug("Set stripePreviewInfo for modelId = " + model.id);

                        if (angular.isObject(previewInfo)) {
                            model.stripePreviewInfo = previewInfo;
                        }
                    })
                    .catch(function (reason) {
                        $log.debug("Can not retrieve stripePreviewInfo for modelId = " + model.id);
                    })
                    .finally(function () {
                        canceler.reject();
                        canceler = null;
                    });
            });
        }

        function stripeLoaded() {
            $log.debug("stripeLoaded");
            vm.isStripeLoaded = true;
        }

        function loadStripeFailed() {
            $log.debug("loadStripeFailed");
            vm.isStripeLoaded = false;
        }
    }
})();